define(["require", "exports", "jquery", "./context", "./attributePanel"], function (require, exports, $, context_1, attributePanel_1) {
    "use strict";
    exports.__esModule = true;
    var style = document.createElement('style');
    var sheet = (document.head.appendChild(style).sheet);
    var bubbleRules = [];
    function addRule(selector, css) {
        var ruleText = $.map(css, function (val, key) {
            return key + ":" + val;
        }).join(';');
        return sheet.insertRule(selector + "{" + ruleText + "}", sheet.cssRules.length);
    }
    $(function () {
        $('.description-mark').click(function (evt) {
            evt.preventDefault();
            evt.stopPropagation();
            if (!context_1["default"].isMobile()) {
                var $box = $(evt.currentTarget).closest('.attribute-cell, .attribute-line');
                var left = Math.round(evt.pageX - $box.offset().left);
                var $curBubble = $(evt.currentTarget).next('.bubble-text');
                var visible = !$curBubble.hasClass('closed');
                $('.bubble-text').toggleClass('closed', true);
                $.each(bubbleRules, function () {
                    sheet.deleteRule(0);
                });
                bubbleRules = [];
                bubbleRules.push(addRule('.bubble-text:before', { left: left + 'px' }));
                bubbleRules.push(addRule('.bubble-text:after', { left: left + 'px' }));
                $curBubble.toggleClass('closed', visible);
            }
            else {
                attributePanel_1.toggleAttributePanel(evt);
            }
        });
        $('.bubble-text').click(function (evt) {
            evt.stopPropagation();
        });
        $('body').click(function () {
            $('.bubble-text').toggleClass('closed', true);
        });
    });
});



//////////////////
// WEBPACK FOOTER
// ./Scripts/built/bubbleText.js
// module id = 68
// module chunks = 0